import React from "react";

import styled from "styled-components";

import { Styles } from "../config";

import { getAlignment } from "./util";

const Vessel = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.column ? "column" : "row")};
  flex-wrap: ${(props) =>
    props.nowrap ? "nowrap" : props.column ? "" : "wrap"};
  margin: ${(props) => props.margin || "0"};
  height: ${(props) => props.height || "auto"};
  width: ${(props) => props.width || "100%"};
  background: ${(props) =>
    props.background ? Styles.Color[props.background] : "none"};
  ${(props) => props.alignmentString}

  ${(props) =>
    props.centerMobile &&
    `
    @media (max-width: ${typeof props.centerMobile === "number" ? props.centerMobile : 800
    }px) {
        align-items: center;
        justify-content: center;
        align-self: center;
        justify-self: center;
    }
  

  
  `}
`;



const Flex = ({
  column,
  style,
  width,
  yAlign,
  xAlign,
  nowrap,
  children,

  centerMobile,
  margin,
  height,
  spaceEvenly,
  id,
  className,
  onClick,
  background,
  dropEvents = {},
}) => {
  const alignment = getAlignment({
    column,
    xAlign,
    yAlign,

    spaceEvenly,
  });

  return (
    <Vessel
      id={id}
      className={className}
      column={column}
      onClick={onClick || null}
      style={style || {}}
      width={width}
      nowrap={nowrap}
      height={height}
      background={background}
      centerMobile={centerMobile}
      alignmentString={Object.entries(alignment).reduce((acc, [key, value]) => {
        acc += `${key}: ${value};`;
        return acc;
      }, "")}
      margin={margin}
      {...dropEvents}
    >
      {children}
    </Vessel>
  );
};

export default Flex;
